import { ResponsiveTypographyVariant } from '@se-admin/falcon';
import { i18n } from '@secret-escapes/i18n';
import * as React from 'react';
import { TranslationsContext } from '../../common/contexts';
import BookingCard from '../BookingCard/BookingCard';
import { IBookingCardListProps } from './BookingCardList.interfaces';
import { NoBookingsText } from './BookingCardList.styles';

export const BookingCardList: React.FunctionComponent<IBookingCardListProps> = props => {
  const { bookings, variant } = props;
  const { translations } = React.useContext(TranslationsContext);
  const translationKey: string = `bookings.no.${variant}`;

  return (
    <React.Fragment>
      {bookings.length > 0 ? (
        bookings.map((booking, i) => <BookingCard booking={booking} key={i} />)
      ) : (
        <NoBookingsText variant={ResponsiveTypographyVariant.t5Sans}>
          {i18n(translationKey, [], translations)}
        </NoBookingsText>
      )}
    </React.Fragment>
  );
};
